import { BREAKPOINT } from "app/layout/constants";
import React, { Dispatch } from "react";

let mq: MediaQueryList | null = null;
const callbacks: Dispatch<boolean>[] = [];

if (typeof window !== "undefined" && window.matchMedia) {
    mq = window.matchMedia(BREAKPOINT);

    // @ts-ignore
    mq.addListener(() => {
        // @ts-ignore
        callbacks.forEach(cb => cb(mq.matches));
    });
}

/**
 * Returns true if screen size > desktop breakpoint.
 * Will trigger re-renders upon change.
 */
export const useBreakpoint = () => {
    const [, update] = React.useState(false);

    React.useEffect(() => {
        callbacks.push(update);
        return () => {
            const i = callbacks.indexOf(update);
            callbacks.splice(i, 1);
        };
    }, [update]);

    if (mq === null) {
        return false;
    }

    return mq.matches;
};
